<template>
  <div style="position: absolute; min-width: 200px; height:50px;">
      <div class="tw-ws-number" v-for="(val, id) in numArray" :key="id" :style="{fontSize: `${fontSize}px`, color: fontColor}">
          <tw-ws-countTo :endValue="val" :millisec="millisec"></tw-ws-countTo>
      </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import twWsCountTo from './tw-ws-countTo'

export default {
    name: "tw-ws-number",
    components: {
        'tw-ws-countTo': twWsCountTo
    },
    setup(props){
        const numArray = computed(() => {
            if(props.value){
                return String(props.value).split('');
            } else {
                return ''
            }
        })

        return {
            numArray
        }
    },
    props: {
        value:{
            type: Number,
            default: 12345
        },
        fontSize: Number,
        fontColor: {
            type: String,
            default: '#FFFFFF'
        },
        millisec: {
            type: Number,
            default: 50
        }
    },
}
</script>

<style>

</style>
